export const parseImagePaths = (data: any, rootImagePath: string) => {
  Object.keys(data).forEach(key => {
    if (typeof data[key] === 'object') {
      parseImagePaths(data[key], rootImagePath);
    } else if (key === 'src' && data[key].indexOf('/') === 0) {
      data[key] = rootImagePath + data[key];
    }
  });
};
